





















import Vue from "vue";
import {Component} from "vue-property-decorator";
import {RouteNames} from "@/router/types";
import {Getter} from "vuex-class";
import {TournamentsModuleGetterTypes} from "@/store/modules/tournaments/types";
import {StoreNamespace} from "@/store/types";
import {ITournamentEntity} from "@/core/tournaments/tournament.entity";
import {Timing} from "@/core/helpers/Timing";
import CircularLoading from "@/components/Loading/CircularLoading.vue";
import TournamentListCard from "@/components/Tournaments/TournamentListItem/TournamentListCard.vue";
import {Moment} from "moment";
import {VuexState} from "@/core/vuex/types";
import {TournamentsStoreModule} from "@/store";
import {TournamentTypes} from "@/core/tournaments/types";
import Pagination from "@/components/Shared/Pagination.vue";
import {IPagination} from "@/core/service/types";

@Component({
  components: {Pagination, TournamentListCard, CircularLoading},
  enums: {
    RouteNames,
    VuexState
  }
})
export default class AvailableTournamentsPage extends Vue {
  @Getter(TournamentsModuleGetterTypes.AVAILABLE_TOURNAMENTS, { namespace: StoreNamespace.Tournaments })
  private readonly tournaments!: ITournamentEntity[]

  @Getter(TournamentsModuleGetterTypes.AVAILABLE_TOURNAMENTS_VUEX_STATE, { namespace: StoreNamespace.Tournaments })
  private readonly currentState!: boolean

  @Getter(TournamentsModuleGetterTypes.AVAILABLE_TOURNAMENTS_PAGINATION, { namespace: StoreNamespace.Tournaments })
  private readonly pagination!: IPagination

  private interval: NodeJS.Timeout | null = null
  private dateTimeNow: Moment = Timing.getTimeNow()

  private async created () {
    await TournamentsStoreModule.initializeAvailableTournaments()
    this.startTimer()
  }

  private startTimer () {
    this.interval = setInterval(() => {
      this.dateTimeNow = Timing.getTimeNow()
    }, 1000)
  }

  private stopTimer () {
    if (this.interval != null) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  private beforeDestroy () {
    this.stopTimer()
    TournamentsStoreModule.clearStore()
  }

  private onCurrentPageChange (newCurrentPage: number) {
    TournamentsStoreModule.onCurrentPaginationPageChange({
      dataType: TournamentTypes.Available,
      newCurrentPage: newCurrentPage
    })
  }
}
